import { render, staticRenderFns } from "./Rubros.vue?vue&type=template&id=5b81dee1&scoped=true&"
import script from "./Rubros.vue?vue&type=script&lang=js&"
export * from "./Rubros.vue?vue&type=script&lang=js&"
import style0 from "./Rubros.vue?vue&type=style&index=0&id=5b81dee1&lang=scss&scoped=true&"
import style1 from "./Rubros.vue?vue&type=style&index=1&id=5b81dee1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81dee1",
  null
  
)

export default component.exports